export default ({ isDrawerOpen }) => ({ isDrawerOpen: !isDrawerOpen });
